<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-6"></div>
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <router-link
                                            :to="{ name: 'Panel' }"
                                            target="_blank"
                                            class="btn btn-primary mr-2"
                                            v-b-tooltip.hover
                                            title="Panel Posting"
                                        >
                                            <i class="mdi mdi-open-in-new"></i>
                                        </router-link>
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            menu-class="dropdown-menu-250"
                                            class="mr-2"
                                            right
                                            v-b-tooltip.hover
                                            :title="$t('label.filter')"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.location') }}
                                                </label>
                                                <multiselect
                                                    v-model="locationFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="locationDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.panelType') }}
                                                </label>
                                                <multiselect
                                                    v-model="panelTypeFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="panelTypeDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.status') }}
                                                </label>
                                                <multiselect
                                                    v-model="isActive"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="statusDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                        <b-button
                                            variant="info"
                                            v-on:click="openForm"
                                            v-b-tooltip.hover
                                            :title="$t('label.createX', [])"
                                        >
                                            <i class="mdi mdi-plus"></i>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(phone)="data">
                                    <span>{{ data.item.phone ? `${data.item.phoneCode || ''} ${data.item.phone}`.trim() : '--' }}</span>
                                </template>
                                <template #cell(type)="data">
                                    <span>{{ data.item.panelType ? data.item.panelType.name : '--' }}</span>
                                </template>
                                <template #cell(location)="data">
                                    <span>{{ data.item.location ? data.item.location.name : '--' }}</span>
                                </template>
                                <template #cell(mapLink)="data">
                                    <a v-if="data.item.mapLink" :href="data.item.mapLink" target="_blank" rel="noopener noreferrer" class="text-info">
                                        <i class="mdi mdi-map-marker-outline mr-1"></i>
                                    </a>
                                    <span v-else>--</span>
                                </template>
                                <template #cell(status)="data">
                                    <b-badge
                                        :variant="tableRows[data.index].isActive ? 'success' : 'secondary'"
                                    >
                                        {{ tableRows[data.index].isActive ? $t('label.active') : $t('label.inactive') }}
                                    </b-badge>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info"
                                        v-b-tooltip.hover
                                        :title="$t('label.updateX', [])"
                                        @click.stop="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="data.item.isActive==0?$t('label.restoreX', []):$t('label.deleteX', [])"
                                        v-on:click="deleteConfirmation(data.item)"
                                    >
                                        <i :class="[`mdi font-size-18 mdi-delete-${data.item.isActive==0?'restore':'outline'}`]"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="panel-form"
            :title="$t(panel.uuid ? 'label.updateX' : 'label.createX', [$t('module.panel')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            centered
        >
            <b-container fluid>
                <PanelForm
                    :panelUUID="panel.uuid"
                    :searchCriteria="searchCriteria"
                    @done="closeForm"
                    ref="panelForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="panel-delete"
            :title="panel.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
            @hidden="closeForm"
            hide-header-close
        >
            <p class="my-4">{{ panel.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('panel-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestDelete"
                    :disabled="!status.save"
                >
                    {{ panel.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { panelMethods, lookupMethods } from "@/state/api";
import { PANEL_MODULE } from "@/state/api/panel.state";
import PanelForm from "@/views/pages/admin/panel/panelForm";

export default {
    components: { Multiselect, PanelForm },
    async created() {
        await this.lookupLocation({});
        await this.lookupPanelType({});
        sessionHelper.clearSearch(SESSION.PANEL_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();
    },
    data() {
        return {
            filter: "",
            searchCriteria: {},
            locationFilter: null,
            panelTypeFilter: null,
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            fields: [
                { key: 'name', label: i18n.t("label.name"), sortable: true, class: 'text-nowrap' },
                { key: 'phone', label: i18n.t("label.phone"), sortable: true, class: 'text-nowrap' },
                { key: 'email', label: i18n.t("label.email"), sortable: true, class: 'text-nowrap' },
                { key: 'type', label: i18n.t("module.panelType"), sortable: true, class: 'text-nowrap' },
                { key: 'location', label: i18n.t("module.location"), sortable: true, class: 'text-nowrap' },
                { key: 'mapLink', label: 'Map Link', sortable: false, class: 'text-nowrap' },
                { key: 'status', label: i18n.t("label.status"), sortable: false, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            panel: {
                uuid: "",
                isActive: false,
            },
        };
    },
    methods: {
        ...panelMethods,
        ...lookupMethods,
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.PANEL_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PANEL_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.isActive.value,
                    location: null,
                    panelType: null,
                    searchValue: "",
                    searchArray: [],
                };
            }
            this.getPanelList(this.searchCriteria);
        },
        getPanelList(filter) {
            this.getAllPanel({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.PANEL_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.PANEL_SEARCH);
            filter.pageNumber = pageNumber;
            this.getPanelList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.isActive = this.isActive.value;
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            if (this.locationFilter?.value == 1)
                delete this.searchCriteria.location;
            else if (this.locationFilter?.value)
                this.searchCriteria.location = this.locationFilter.value;

            if (this.panelTypeFilter?.value == 1)
                delete this.searchCriteria.panelType;
            else if (this.panelTypeFilter?.value)
                this.searchCriteria.panelType = this.panelTypeFilter.value;

            this.getPanelList(this.searchCriteria);
        },
        deleteConfirmation(data) {
            this.panel = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('panel-delete');
        },
        requestDelete() {
            let data = {
                uuid: this.panel.uuid,
                isActive: this.panel.isActive == 0 ? 1 : 0,
            };
            this.updatePanelStatus({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('panel-delete');
                }));
        },
        openForm(data) {
            if (data?.uuid) {
                this.panel = {
                    uuid: data.uuid,
                    isActive: data.isActive,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('panel-form');
            });
        },
        closeForm() {
            this.panel = {
                uuid: "",
                isActive: false,
            };
            this.$bvModal.hide('panel-form');
        },
    },
    computed: {
        ...mapState(PANEL_MODULE, ['status']),
        locationDdl() {
            return [
                { value: 1, text: i18n.t('label.all') },
                ...this.$store.state.api.lookup.locationDdl,
            ];
        },
        panelTypeDdl() {
            return [
                { value: 1, text: i18n.t('label.all') },
                ...this.$store.state.api.lookup.panelTypeDdl,
            ];
        },
        tableRows() {
            return this.$store.state.api.panel.list.data || [];
        },
        totalPage() {
            return this.$store.state.api.panel.list.pagination.total || 0;
        },
    },
}
</script>
